'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpecificity = exports.mergeByType = exports.raf = exports.isSameType = exports.isObject = exports.isFunction = exports.isString = exports.isArray = exports.truthy = exports.identity = undefined;

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.memoizeByClassNames = memoizeByClassNames;
exports.memoizeByFirst = memoizeByFirst;
exports.createEmitter = createEmitter;
exports.defaultComponentConfigsMerge = defaultComponentConfigsMerge;
exports.mergeStylingPropsCollection = mergeStylingPropsCollection;
exports.flattenPrimitivesAndPropsToProps = flattenPrimitivesAndPropsToProps;
exports.isReactStylingPropsObj = isReactStylingPropsObj;
exports.createStylesThunk = createStylesThunk;
exports.primitivesToPropsObj = primitivesToPropsObj;
exports.getDisplayName = getDisplayName;
exports.warnPoorDisplayName = warnPoorDisplayName;
exports.mergeResolvedStylesWithProps = mergeResolvedStylesWithProps;
exports.treeFromPaths = treeFromPaths;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = exports.identity = function identity(x) {
  return x;
};
var truthy = exports.truthy = function truthy(x) {
  return !!x;
};
var isArray = exports.isArray = function isArray(x) {
  return Array.isArray(x);
};
var isString = exports.isString = function isString(x) {
  return typeof x === 'string';
};
var isFunction = exports.isFunction = function isFunction(x) {
  return typeof x === 'function';
};
var isObject = exports.isObject = function isObject(x) {
  return (typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) === 'object';
};
var isSameType = exports.isSameType = function isSameType(a, b, type) {
  return type(a) && type(b);
};
var raf = exports.raf = (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) === 'object' && window.requestAnimationFrame || function (_) {
  return _();
};

var STYLE_PROP_NAMES = ['style', 'className'];
if (process.env.NODE_ENV !== 'production') {
  STYLE_PROP_NAMES.push('data-styletarget');
}

function memoize(fn, transformArgs, serializeArgsToKey) {
  var cache = new _map2.default();
  return function memoized() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _args = transformArgs(args);
    var key = serializeArgsToKey(_args, args);
    if (!cache.has(key)) {
      var result = fn.apply(undefined, (0, _toConsumableArray3.default)(_args));
      cache.set(key, result);
    }
    return cache.get(key);
  };
}

var argsToClassnames = function argsToClassnames(names) {
  return (0, _classnames2.default)(names).split(' ');
};
var flattenClassnames = function flattenClassnames(finalNames) {
  return finalNames.sort().join(' ');
};
function memoizeByClassNames(fn) {
  return memoize(fn, argsToClassnames, flattenClassnames);
}

var first = function first(arr) {
  return arr[0];
};
function memoizeByFirst(fn) {
  return memoize(fn, identity, first);
}

/**
 * Event Emitter constructor.
 * Creates an object that can store subscriber functions, and later call them
 * when the object's `emit` function is called. Bare-minimum.
 */
function createEmitter() {
  var subscribers = [];
  return {
    on: function on(sub) {
      subscribers = subscribers.concat(sub);
    },
    off: function off(sub) {
      subscribers = subscribers.filter(function (next) {
        return next !== sub;
      });
    },
    emit: function emit() {
      subscribers.forEach(function (sub) {
        return sub();
      });
    }
  };
}

var _defaultMerge = function _defaultMerge(a, b) {
  return a || b;
};
/**
 * Merges A into B, with types intact.
 * A takes precedence over B when types do not match, or values are missing.
 *
 * @param {*} a
 *       First value. Is merged into B.
 * @param {*} b
 *       Second value.
 * @param {function(a, b)} defaultMerge
 *       Merges a and b if types don't match.
 * @returns {*}
 *       The merged value, with the same type as A.
 */
var mergeByType = exports.mergeByType = function mergeByType(a, b) {
  var defaultMerge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _defaultMerge;

  // Strings
  if (isSameType(a, b, isString)) {
    return a + ' ' + b;
    // Objects
  } else if (isSameType(a, b, isObject)) {
    return (0, _extends3.default)({}, a, b);
    // Everything else
  } else {
    return defaultMerge(a, b);
  }
};

var takeB = function takeB(a, b) {
  return b;
};

/**
 * Merges to component configs together.
 *  1. Merges the class name / style object of segments for components that match
 *  2. If types for segments don't match, the primitive from configB is used
 * @param {Object} configA
 *       The first component config.
 * @param {Object} configB
 *       The Second component config.
 * @returns {Object}
 */
function defaultComponentConfigsMerge() {
  var configA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var configB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var configC = (0, _extends3.default)({}, configA, configB);
  (0, _keys2.default)(configB).forEach(function (componentName) {
    var stylesObjA = configA[componentName];
    var stylesObjB = configB[componentName];
    if (stylesObjA) {
      configC[componentName] = (0, _extends3.default)({}, stylesObjA, stylesObjB);
      (0, _keys2.default)(stylesObjB).forEach(function (segmentName) {
        var segmentA = stylesObjA[segmentName];
        var segmentB = stylesObjB[segmentName];
        if (segmentA) {
          configC[componentName][segmentName] = mergeByType(segmentA, segmentB, takeB);
        }
      });
    }
  });
  return configC;
}

/**
 * Merges the `style`/`className` values of several React prop objects.
 * @param {Object[]} propsCollection - An array of React prop objects.
 * @returns {{style, className}}
 *       A React prop object, with `style` and/or `className` properties merged.
 */
function mergeStylingPropsCollection(propsCollection) {
  if (propsCollection.length > 1) {
    return propsCollection.reduce(function (finalProps, currentProps) {
      STYLE_PROP_NAMES.forEach(function (propName) {
        if (truthy(currentProps[propName])) {
          var previousPropValue = finalProps[propName];
          finalProps[propName] = mergeByType(previousPropValue, currentProps[propName]);
        }
      });

      return finalProps;
    }, {});
  } else {
    return (0, _assign2.default)({}, propsCollection[0]);
  }
}

/**
 * Given an array of either React props, class name strings or style objects,
 * this will merge all values into a single React props object.
 * @param primitivesAndProps
 * @returns {{style, className}}
 */
function flattenPrimitivesAndPropsToProps(primitivesAndProps) {
  var primitives = primitivesAndProps.reduce(function (primitives, propsObjOrOther) {
    if (isReactStylingPropsObj(propsObjOrOther)) {
      return STYLE_PROP_NAMES.reduce(function (primitives, stylePropName) {
        var primitive = propsObjOrOther[stylePropName];
        if (primitive) {
          return appendToPrimitivesObj(primitive, primitives);
        } else {
          return primitives;
        }
      }, primitives);
    } else {
      return appendToPrimitivesObj(propsObjOrOther, primitives);
    }
  }, {});
  return primitivesToPropsObj(primitives);
}

function isReactStylingPropsObj(obj) {
  return isObject(obj) && STYLE_PROP_NAMES.some(function (name) {
    return name in obj;
  });
}

var DEFAULT_TRACE_DECORATOR = function DEFAULT_TRACE_DECORATOR(segment, component) {
  return component + '.' + segment;
};
var DEFAULT_THEMEABLE_OPTIONS = {
  traceDecorator: DEFAULT_TRACE_DECORATOR,
  traceDisplayName: '<Unknown>'
};

var getStylesThunkOptions = memoizeByFirst(function (options) {
  return (0, _assign2.default)({}, DEFAULT_THEMEABLE_OPTIONS, options);
});

/**
 * Given names of theme segments, generates an object ot be used as React props.
 * @callback themeablePropGenerator
 * @param {...String} names - The names found in the 'Theme' object.
 * @return {{ style, className }}
 */

/**
 * Given a 'Theme' object (style primitives keyed by name), creates a function
 * to later generate an object with `style` and/or `className` properties.
 *
 * The returned function can be called with names of used in the 'Theme' object.
 *
 * Code initially fork from https://github.com/markdalgleish/react-themeable.
 *
 * @param {Object|Array} themeArgs
 *        Either the Theme object, or an array shaped like:
 *        [Theme, ClassNamesDecorator]
 *        The ClassNameDecorator is a function is used to transform the values
 *        in Theme to a string for the `className` prop of the generated object.
 * @param {{traceDecorator, displayName}} [options] - Options for the theme utility.
 * @returns {themeablePropGenerator}
 *        Function that generates an object to be used as a React props object.
 *        The
 *        It will contain `style` and/or `className` properties.
 */
function createStylesThunk(themeArgs, options) {
  options = getStylesThunkOptions(options);

  var theme = void 0,
      classNamesDecorator = void 0;
  if (isArray(themeArgs) && themeArgs.length > 1) {
    theme = themeArgs[0];
    classNamesDecorator = themeArgs[1];
  } else {
    theme = themeArgs;
  }

  return function () {
    for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      names[_key2] = arguments[_key2];
    }

    names = (0, _classnames2.default)(names).split(' ');
    return primitivesToPropsObj(names.reduce(function (primitives, name) {
      var primitive = theme[name];
      if (!truthy(primitive)) return primitives;

      return appendToPrimitivesObj(primitive, primitives, classNamesDecorator, name, options);
    }, {}));
  };
}

/**
 * Takes a classOrStyle, and merges it into primitivesObj to be tracked until it
 * gets transformed into a React prop object ({ className, style }).
 * @param {String|Object} primitive
 *        Either a class name, or an object of style properties/values.
 * @param {{ styles, classes, traces }} primitives
 *        An object for tracking styling primitves.
 * @param {function(Object)} classNameDecorator
 *        A function to transform the classOrStyle into a class, when found to be an object initially.
 * @param {String} [name]
 *        The name of the style segment.
 * @param {{traceDecorator, displayName}} [options]
 *        Options for the theme utility.
 * @returns {*}
 */
function appendToPrimitivesObj(primitive, primitives, classNameDecorator, name, options) {
  // Append class names and style objects for application
  if (isString(primitive)) {
    primitives.classes = (primitives.classes || []).concat(primitive);
  } else if (isFunction(classNameDecorator)) {
    primitives.classes = (primitives.classes || []).concat(classNameDecorator(primitive));
  } else {
    primitives.styles = (primitives.styles || []).concat(primitive);
  }

  // Append traces to debug how element-styles resolved styles for an element
  if (process.env.NODE_ENV !== 'production' && options && name) {
    primitives.traces = (primitives.traces || []).concat(options.traceDecorator(name, options.traceDisplayName));
  }

  return primitives;
}

/**
 * Takes an object created by 'appendToPrimitives', and creates a new object to
 * be used on React elements.
 * @param {{ styles, classes, traces }} primitives
 * @returns {{ style, className }}
 */
function primitivesToPropsObj(primitives) {
  var props = {};
  if (primitives.classes) {
    props.className = primitives.classes.join(' ');
  }
  if (primitives.styles) {
    props.style = _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(primitives.styles)));
  }

  if (process.env.NODE_ENV !== 'production') {
    if (primitives.traces) {
      // Dedupe similar traces.
      var allTraces = (0, _from2.default)(new _set2.default((props['data-styletarget'] || '').split(', ').concat(primitives.traces).filter(Boolean)));
      props['data-styletarget'] = allTraces.join(', ');
    }
  }

  return props;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name;
}

var INVALID_COMPONENT_NAME = /[()\-!@#$%^&*]/;
var INNER_COMPONENT_NAME = /.*\(([\w]+)\)/i;

function warnPoorDisplayName(displayName) {
  if (!displayName) {
    console.warn('Component given to `styled` doesn\'t have name! Component cannot be used with `<StylesProvider />` from element-styles.\n\nYou might be trying to wrap a stateless component with `styled`; try add a `displayName` property to the function.');
  } else if (INVALID_COMPONENT_NAME.test(displayName)) {
    var name = INNER_COMPONENT_NAME.exec(displayName) || [];
    name = name[1] ? '"' + name[1] + '"' : 'Composite';
    console.warn('The following name isn\'t suitable for usage with `<StylesProvider />` in element-styles:\n\n  "' + displayName + '"\n\nYou might be using `styled` on a High Order Component; consider wrapping the ' + name + ' Component with `styled` before any other HOC.');
  }
}

function mergeResolvedStylesWithProps(styles, _ref, names) {
  var className = _ref.className,
      style = _ref.style;

  var _styles = styles.apply(undefined, (0, _toConsumableArray3.default)(names)),
      sourceClassName = _styles.className,
      sourceStyle = _styles.style;

  var mergedProps = {};

  if (sourceClassName || className) {
    mergedProps.className = (0, _classnames2.default)(className, sourceClassName);
  }
  if (sourceStyle || style) {
    mergedProps.style = (0, _assign2.default)({}, sourceStyle || {}, style);
  }

  return mergedProps;
}

/*
 * https://github.com/atom/clear-cut
 */

var SELECT_ELEMENT_REGEX = /([^\s+>~.[:]+)/g;
var SELECT_SEPARATOR_REGIX = /[\s+>~]/g;

function findSelectorPartMatch(regex, type, types, selector) {
  var matches = selector.match(regex);
  if (matches) {
    for (var i = 0; i < matches.length; i++) {
      types[type]++;
      // Replace this simple selector with whitespace so it won't be counted in
      // further simple selectors
      selector = selector.replace(matches[i], ' ');
    }
  }

  return selector;
}

var calculateSelector = function calculateSelector(selector) {
  var commaIndex = selector.indexOf(',');
  if (commaIndex !== -1) {
    selector = selector.substring(0, commaIndex);
  }

  var types = { a: 0, b: 0, c: 0 };

  // Remove universal selector and separator characters
  selector = selector.replace(SELECT_SEPARATOR_REGIX, ' ');

  // The only things left should be element selectors (type c)
  findSelectorPartMatch(SELECT_ELEMENT_REGEX, 'c', types, selector);

  return types.a * 100 + types.b * 10 + types.c * 1;
};

/**
 * Given a selector, it will given a numerical value to represent the specificity
 * it will have in CSS engines.
 * @param selector
 * @returns {*}
 */
var getSpecificity = exports.getSpecificity = memoizeByFirst(calculateSelector);

function treeFromPaths(paths) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var node = { name: paths[i] };
  if (i < paths.length - 1) {
    node.children = [treeFromPaths(paths, i + 1)];
  }
  return node;
}